import st from "lib/utils/index";
import { ProductsRepository, PricingPlansRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "accommodation/AccommodationCommonView/INITIALIZE_VIEW";

export const FETCH_PRODUCTS = "accommodation/AccommodationCommonView/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_START = "accommodation/AccommodationCommonView/FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "accommodation/AccommodationCommonView/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "accommodation/AccommodationCommonView/FETCH_PRODUCTS_FAILURE";

export const FETCH_PRICING_PLANS = "accommodation/AccommodationCommonView/FETCH_PRICING_PLANS";
export const FETCH_PRICING_PLANS_START = "accommodation/AccommodationCommonView/FETCH_PRICING_PLANS_START";
export const FETCH_PRICING_PLANS_SUCCESS = "accommodation/AccommodationCommonView/FETCH_PRICING_PLANS_SUCCESS";
export const FETCH_PRICING_PLANS_FAILURE = "accommodation/AccommodationCommonView/FETCH_PRICING_PLANS_FAILURE";

export const stateSelector = (state) => state.accommodation.AccommodationCommonView;

export const dateFormat = "YYYY-MM-DD";
export const getMinDate = () => moment().subtract(1, "years").format(dateFormat);
export const getMaxDate = () => moment().add(12, "months").format(dateFormat);

export const availabilityTypes = {
  instant: "available_with_instant_booking",
  approval: "available_with_company_approval",
};
export const availabilityTypesOptions = Object.values(availabilityTypes).map((availabilityType) => [
  availabilityType,
  I18n.t(`papp.accommodation.AccommodationSchedulerView.availabilityTypes.${availabilityType}`),
]);

const productsResource = createResourceInstance({
  FETCH: FETCH_PRODUCTS,
  FETCH_START: FETCH_PRODUCTS_START,
  FETCH_SUCCESS: FETCH_PRODUCTS_SUCCESS,
  FETCH_FAILURE: FETCH_PRODUCTS_FAILURE,
  stateSelector,
  stateKey: "products",
  getModel: () => {
    return ProductsRepository.search({ product_type: "accommodation", limit: 1000 });
  },
});

const pricingPlansResource = createResourceInstance({
  FETCH: FETCH_PRICING_PLANS,
  FETCH_START: FETCH_PRICING_PLANS_START,
  FETCH_SUCCESS: FETCH_PRICING_PLANS_SUCCESS,
  FETCH_FAILURE: FETCH_PRICING_PLANS_FAILURE,
  stateSelector,
  stateKey: "pricingPlans",
  getModel: () => {
    return PricingPlansRepository.findAll();
  },
});

const initialState = {
  products: productsResource.initialState,
  pricingPlans: pricingPlansResource.initialState,
};

const reducers = {
  ...productsResource.reducersMap,
  ...pricingPlansResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...productsResource.epics,
  ...pricingPlansResource.epics,

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchProducts()),

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchPricingPlans()),
];

export const { fetch: fetchProducts } = productsResource.actions;
export const { fetch: fetchPricingPlans } = pricingPlansResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/accommodation/common.js